<template>
  <table>
    <thead>
      <tr>
        <slot name="slot_head"/>
      </tr>
    </thead>
  <Draggable tag="tbody"  v-model="rows" v-if="draggable" class="draggableTBody">
    <slot v-for="(row, r) in rows" :item="row" :index="r">
    </slot>
    <tr :style="{marginBottom: 'auto', border:'none'}"></tr>
  </Draggable>
    <tbody v-else>
      <slot v-for="(row, r) in rows" :item="row" :index="r"/>
    </tbody>
  <tfoot>
    <tr :style="{marginBottom: 'auto',height: '-webkit-fill-available'}"></tr>
  </tfoot>
  </table>
</template>

<script>
import Draggable from 'vuedraggable'
export default {
  props: ['rows', 'draggable'],
  components: { Draggable },
  data () {
    return {
      rowsSort: []
    }
  },
  mounted () {
  },
  watch: {
    rows () {
      this.$emit('sort', this.rows)
    }
  }
}
</script>
<style lang="scss">
.draggableTBody {
  td {
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #6D6D6D;
  border: none;
  padding-inline: 10px;
  &:nth-child(1) {
    padding-left: 32px;
  }
  }
}
</style>
<style lang="scss" scoped>
td, th {
  border:1px solid gray;
  width:100px;
  height:30px;
}
th {
  height: 40px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.1em;
  color: #000000;
  align-items: center;
  height: 40px;
  white-space: nowrap;
}
table {
  table-layout: fixed;
  width: 100%; /* 固定寬度 */
  border-collapse: collapse;
}

td:first-child, th:first-child {
  position:sticky;
  left:0; /* 首行永遠固定於左 */
  z-index:1;
}
thead tr th {
  position:sticky;
  top:0; /* 列首永遠固定於上 */
  z-index:2;
  background-color: #fffae7;
}
thead tr {
  height: 40px;
}
tbody tr {
  height: 100px;
}
th:first-child{
  z-index:2;
}
th, td {
  border: none;
  padding-inline: 10px;
  &:nth-child(1) {
    padding-left: 32px;
  }
}
thead {
  background-color: #FFFFFF;
}
td {
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #6D6D6D;
}
</style>
